// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-layout[data-v-360d9b60] {\n  min-height: 100vh;\n}\n.page__header[data-v-360d9b60] {\n  background: #f1f2f5;\n}\n.page__header.page__header--min-height[data-v-360d9b60] {\n  min-height: 124px;\n  z-index: 20 !important;\n}", ""]);
// Exports
module.exports = exports;
